/**
 * Convert a `File` object returned by the upload input into
 * a base 64 string. That's easier to use on FakeRest, used on
 * the ng-admin example. But that's probably not the most optimized
 * way to do in a production database.
 */
const convertFileToBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});

/**
 * Convert uploaded image in base 64 and attach it to
 * the `thumbnail` sent property, with `src` and `title` attributes.
 */
const addUploadCapabilities = requestHandler => (type, resource, params) => {
    if (type === 'UPDATE' || type === 'CREATE') {
        if (params.data.thumbnail && params.data.thumbnail.length && params.data.thumbnail[0].rawFile instanceof File) {
            const thumbnailFile = params.data.thumbnail[0].rawFile;
            return Promise.resolve(convertFileToBase64(thumbnailFile))
                .then(thumbnail => {
                    return requestHandler(type, resource, {
                    ...params,
                    data: {
                        ...params.data,
                        thumbnail,
                    },
                    });
                }
            );
        }
        else if (params.data.cover_image && params.data.cover_image.length && params.data.cover_image[0].rawFile instanceof File) {
            const coverImageFile = params.data.cover_image[0].rawFile;
            return Promise.resolve(convertFileToBase64(coverImageFile))
                .then(cover_image => {
                    return requestHandler(type, resource, {
                    ...params,
                    data: {
                        ...params.data,
                        cover_image,
                    },
                    });
                }
            );
        }
        else if (params.data) {
            if (params.data.thumbnail && params.data.thumbnail.url) {
                params.data.thumbnail = params.data.thumbnail.url;
            }
            else if (params.data.cover_image && params.data.cover_image.url) {
                params.data.cover_image = params.data.cover_image.url;
            }
        }
    }

    return requestHandler(type, resource, params);
};

export default addUploadCapabilities;


// WEBPACK FOOTER //
// ./src/addUploadHandler.js